import styled from 'styled-components';
import { formatViewport } from 'utils/get-pixels-to-viewport';
import { overflowScrollAnimation } from 'utils/overflow-scroll-animation';

import { ANNOUNCEMENT_DESCRIPTION_LINES } from 'components/widgets/widget-announcements/constants';

const DESCRIPTION_LINE_HEIGHT = 1.4;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: ${formatViewport(1)} solid ${({ theme }) => theme.border.primary};
  border-radius: 2%;
  overflow: hidden;
`;

export const ImageContainer = styled.div`
  /* Takes whatever the text leaves over, but never gives up more than half the card. */
  flex: 1;
  min-height: 50%;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
`;

export const Image = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const LogoContainer = styled.div`
  position: absolute;
  bottom: ${formatViewport(10)};
  left: ${formatViewport(10)};
  width: 20%;
  aspect-ratio: 16/9;

  max-height: 70%;
`;

export const Logo = styled.img`
  object-fit: contain;
  object-position: bottom left;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const InfoContainer = styled.div`
  /* Grows with the text, but only up to half the card so the image is always visible. */
  flex: 0 1 auto;
  max-height: 50%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 3%;
  overflow: hidden;
  color: ${({ theme }) => theme.text.primary};
`;

export const Title = styled.div`
  flex-shrink: 0;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${formatViewport(23)};
`;

export const Description = styled.div`
  flex-shrink: 0;
  margin-top: ${formatViewport(15)};
  font-size: ${formatViewport(16)};
  line-height: ${DESCRIPTION_LINE_HEIGHT};
  max-height: ${ANNOUNCEMENT_DESCRIPTION_LINES * DESCRIPTION_LINE_HEIGHT}em;
  overflow: hidden;
`;

export const DescriptionText = styled.span<{ $isScrolling: boolean }>`
  display: block;
  overflow-wrap: anywhere;

  ${({ $isScrolling }) => $isScrolling && overflowScrollAnimation('vertical')}
`;
